define.alias("checkout/components/seamless-checkout/non-admin-modal", "settings/components/seamless-checkout/non-admin-modal");